import React from 'react';
import { ClassificationBadgeDisplay } from '../../../utils/classificationBadgeDisplay';
import { ClassificationBadge } from './ClassificationBadge';

interface ClassificationBadgesProps {
  badges: ClassificationBadgeDisplay[];
  compact?: boolean;
  className?: string;
}

export const ClassificationBadges: React.FC<ClassificationBadgesProps> = ({
  badges,
  compact = false,
  className = '',
}) => {
  if (badges.length === 0)
  {
    return null;
  }

  return (
    <span className={`inline-flex items-center flex-wrap gap-1 ${className}`}>
      {badges.map((badge) => (
        <ClassificationBadge
          key={`${badge.fieldCode}-${badge.slug}`}
          badge={badge}
          compact={compact}
        />
      ))}
    </span>
  );
};
